import React from "react";

const NaukriComponent = () => {
  return (
    <div>
      <h2>Naukri.com</h2>
      <p>Find remote job opportunities on Naukri.com:</p>
      <a href="https://www.naukri.com/">Naukri.com - Remote Jobs</a>
      <p>
        Naukri.com is one of India's largest job portals offering a vast array
        of job opportunities across various sectors and job roles. Users can
        create profiles, upload resumes, and search for jobs based on their
        preferences. The platform allows job seekers to filter their searches
        for remote or work-from-home positions, making it easier to find
        opportunities that suit their desired work arrangements.
      </p>
    </div>
  );
};

export default NaukriComponent;
